<template>
    <v-modal-slot size="xl">
        <template v-slot:modal-title>
            Cómo usar los shortcodes
        </template>

        <template v-slot:modal-content>
            <div class="row">
                <div class="col-12">
                    <h4>Shortcodes</h4>
                    <p>Los shortcodes se utilizan incluyéndolos tal cual en las plantillas. Si quieres que en la
                        plantilla aparezca el municipio del cliente, deberás incluir <span class="badge text-black-50">[cliente campo="municipio"]</span> y,
                     si existe ese dato, aparecerá. Si no existe, se mostrará en rojo de forma clara en la
                     previsualización de la plantilla. A continuación se exponen todos los shortcodes disponibles.</p>
                </div>
                <p></p>
                <div class="col-12">
                    <h4>Shortcodes de clientes</h4>
                    <template v-for="client_shortcode in client_shortcodes">
                        <span class="badge text-black-50">
                            [cliente campo="{{ client_shortcode }}"]
                        </span>
                        &nbsp;
                    </template>
                </div>
                <p></p>
                <div class="col-12">
                    <h4>Shortcodes de entidades</h4>
                    <template v-for="entity_shortcode in entity_shortcodes">
                        <span class="badge text-black-50">
                            [entidad campo="{{ entity_shortcode }}"]
                        </span>
                        &nbsp;
                    </template>
                </div>
                <p></p>
                <div class="col-12">
                    <h4>Shortcodes de expediente</h4>
                    <template v-for="expedient_shortcode in expedient_shortcodes">
                        <span class="badge text-black-50">
                            [expediente campo="{{ expedient_shortcode }}"]
                        </span>
                        &nbsp;
                    </template>
                </div>
                <p></p>
                <div class="col-12">
                    <h4>Shortcodes de estado del expediente</h4>
                    <template v-for="status_shortcode in status_shortcodes">
                        <span class="badge text-black-50">
                            [estado nombre="Interponer demanda" campo="{{ status_shortcode }}"]
                        </span>
                        &nbsp;
                        <span class="badge text-black-50">
                            [estado nombre="Burofax Enviado" campo="{{ status_shortcode }}"]
                        </span>
                        &nbsp;
                    </template>
                </div>
                <p></p>
                <div class="col-12">
                    <h4>Shortcodes condicionales del expediente</h4>
                    <span class="badge bg-dark">
                        [si estado="Burofax Enviado" campo="observaciones"]
                    </span>
                    <span class="badge text-black-50">
                        Esto sale si hay un estado 'Burofax Enviado' con algo en observaciones
                    </span>
                    <span class="badge bg-dark">
                        [/si]
                    </span>
                    <p></p>
                    <span class="badge bg-dark">
                        [si estado="Burofax Enviado" campo="fecha"]
                    </span>
                    <span class="badge text-black-50">
                        Esto sale si hay un estado 'Burofax Enviado' con una fecha
                    </span>
                    <span class="badge bg-dark">
                        [/si]
                    </span>
                    <p></p>
                    <span class="badge bg-dark">
                        [si estado="Burofax Enviado"]
                    </span>
                    <span class="badge text-black-50">
                        Esto sale si hay un estado 'Burofax Enviado'
                    </span>
                    <span class="badge bg-dark">
                        [/si]
                    </span>
                </div>
                <p></p>
                <div class="col-12">
                    <h4>Shortcodes de letrados</h4>
                    <template v-for="attorney_and_lawyer_shortcode in lawyers_and_attorneys_shortcodes">
                        <span class="badge text-black-50">
                            [letrado campo="{{ attorney_and_lawyer_shortcode }}"]
                        </span>
                        &nbsp;
                    </template>
                </div>
                <p></p>
                <div class="col-12">
                    <h4>Shortcodes de procuradores</h4>
                    <template v-for="attorney_and_lawyer_shortcode in lawyers_and_attorneys_shortcodes">
                        <span class="badge text-black-50">
                            [procurador campo="{{ attorney_and_lawyer_shortcode }}"]
                        </span>
                        &nbsp;
                    </template>
                </div>
                <p></p>
                <div class="col-12">
                    <h4>Shortcodes de imagen</h4>
                    <span class="badge text-black-50">
                        [imagen categoria="dni"]
                    </span>
                    <span class="badge text-black-50">
                        [imagen categoria="nif"]
                    </span>
                    <span class="badge text-black-50">
                        [imagen categoria="documentacion"]
                    </span>
                    <span class="badge text-black-50">
                        [imagen categoria="autorizacion"]
                    </span>
                    <span class="badge text-black-50">
                        [imagen categoria="firma"]
                    </span>
                    <span class="badge text-black-50">
                        [imagen categoria="otros"]
                    </span>
                    <span class="badge text-black-50">
                        [imagen categoria="otros" redimensionar="25"]
                    </span>
                    <span class="badge text-black-50">
                        [imagen nombre="imagen_ejemplo.jpg"]
                    </span>
                    <span class="badge text-black-50">
                        [imagen nombre="imagen_ejemplo.jpg" redimensionar="25"]
                    </span>
                </div>
                <p></p>
                <div class="col-12">
                    <h4>Shortcodes de datos de plantilla</h4>
                    <p>Siempre puedes solicitar un dato al operador para que lo introduzca en el momento de usar la
                     plantilla, y basta con añadir el shortcode en la propia plantilla y automáticamente se le requerirá
                     al operador. Por ejemplo, si quieres que introduzca una cantidad, colocas el shortcode
                     <span class="badge bg-danger">[introduce_valor campo="cantidad"]</span> y el operador tendrá
                     que introducir esa 'cantidad' cuando use la plantilla correspondiente. Así de sencillo. <span class="badge bg-warning">OJO</span>&nbsp;No utilices como 'campo' un nombre ya utilizado en los shortcodes de expediente o entrarán en conflicto. Es decir, no utilices [introduce_valor campo="notario"] porque ese shortcode ya existe para expediente y tiene su propio campo de formulario en la vista del detalle de expediente.</p>
                </div>
                <p></p>
                <div class="col-12">
                    <h4>Shortcodes de sección o párrafos dinámicos</h4>
                    <p>Puedes hacer que, dentro de una plantilla, un párrafo pueda aparecer o no dependiendo de si el
                     operador quiere usarlo o no. Tendrá que hacer clic para habilitar ese párrafo. Además, puedes
                     hacer que un párrafo active o desactive otros. Para ello, tendrás que darles nombres únicos a las
                     secciones o párrafos dinámicos. Un ejemplo de shortcode sería <span class="badge bg-dark">
                     [seccion nombre="datos_tarjeta" activa="descripcion_tarjeta" desactiva="descripcion_prestamo"]</span>,
                     que crearía una sección 'datos_tarjeta'. Las secciones, igual que las abres, tienes que cerrarlas
                        para que no fallen, con la etiqueta <span class="badge bg-dark">[/seccion]</span>. Si el operador hiciese clic, ese párrafo
                        aparecería en el documento que está generando, y también aparecerá por defecto la sección
                        'descripcion_tarjeta', porque así lo indica ese shortcode (atributo 'activa'). No obstante,
                        puede desactivar esa sección manualmente si quisiera.</p>
                </div>
                <p></p>
                <div class="col-12">
                    <p>
                        Recuerda que las plantillas son para facilitar el trabajo, pero siempre podrán hacer cambios
                         en el último momento para que todo tenga el formato deseado.
                    </p>
                </div>
            </div>
        </template>

        <template v-slot:close-button>
            Cerrar
        </template>
    </v-modal-slot>
</template>

<script>

import VModalSlot from "../../../general/VModalSlot";

export default {
    name: "TemplatesEditShortcodesHelpModal",
    components: {
        VModalSlot
    },
    data() {
        return {
            fields: require('../../../../config/form_fields.json'),
            client_shortcodes: [
                'nombre',
                'apellidos',
                'dni',
                'nif',
                'documento_nacional_identidad',
                'numero_identificacion_fiscal',
                'codigo',

                'tipo_via',
                'nombre_via',
                'numero',
                'portal',
                'bloque',
                'escalera',
                'piso',
                'letra',
                'comunidad',
                'provincia',
                'municipio',
                'localidad',
                'codigo_postal',
                'correo_electronico_uno',
                'email_uno',
                'correo_electronico_dos',
                'email_dos',
                'telefono_uno',
                'telefono_dos',
                'observaciones',
            ],
            entity_shortcodes: [
                'nombre',
                'nombre_corto',
                'dni',
                'nif',
                'numero_identificacion_fiscal',

                'nombre_departamento',
                'telefono_atencion_cliente',
                'nombre_responsable_atencion_cliente',
                'apellidos_responsable_atencion_cliente',
                'tipo_via',
                'nombre_via',
                'numero',
                'portal',
                'bloque',
                'escalera',
                'piso',
                'letra',
                'comunidad',
                'provincia',
                'municipio',
                'location',
                'codigo_postal',
                'correo_electronico_uno',
                'email_uno',
                'correo_electronico_dos',
                'email_dos',
                'observaciones',
            ],
            expedient_shortcodes: [
                'entidad_contratacion_original',
                'notario',
                'numero_protocolo',
                'fecha_firma_escritura',
                'existe_documento_escritura_prestamo_hipotecario',
                'existe_factura_gestoria',
                'existe_factura_registro_propiedad',
                'existe_factura_notaria',
                'existe_factura_tasacion',
                'existe_comision_apertura',
                'existe_clausula_suelo',
                'existe_irph',

                'tipo_demanda',

                'numero_contrato',
                'numero_tarjeta',
                'ano_contratacion',
                'existe_contrato',
                'existe_extractos',
                'tae_contrato',
                'tae_maximo_extractos',
                'existe_contrato_resuelto',
                'lugar_contratacion',
                'deuda_reclamada_entidad',
                'cuadro_ejecucion_recibido',

                'numero_prestamo',

                'numeros_contrato',
                'numeros_prestamo',
                'fechas_contratacion',
                'existe_contratos',

                'entidad_lista',
                'fecha_entrada_listas',
                'fecha_salida_listas',
                'existe_asnef',
                'existe_badexcug',
                'existe_documento_presencia_listas',
                'existe_documentos_prueba_inclusion_ilicita',

                'tipo_procedimiento',
                'partido_judicial',
                'numero_juzgado',
                'numero_auto',
                'reduccion_deuda',
                'dinero_devuelto_cliente',
                'observaciones',
                'cuantia_costas',
            ],
            lawyers_and_attorneys_shortcodes: [
                'nombre',
                'apellidos',
                'dni',
                'numero_colegiado',
                'colegio',
            ],
            status_shortcodes: [
                'fecha',
                'observaciones',
            ],
        }
    },
    mounted() {

    },
    methods: {

    },
}
</script>
